import React, { useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { WA_MESSAGES, openWhatsApp } from '../../../config/site';

const VideoModal = ({ testimonial, isOpen, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!isOpen || !testimonial) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4">
      <div className="absolute inset-0 animate-fade-in bg-black/85 backdrop-blur-sm" onClick={onClose} aria-hidden="true" />

      <div className="perspective relative w-full max-w-3xl">
        <div className="animate-pop-3d overflow-hidden rounded-[26px] border border-white/12 bg-[#0B0B14] shadow-[0_50px_100px_-30px_rgba(0,0,0,1)]">
          <div className="relative aspect-video bg-black">
            <video
              src={testimonial.videoUrl}
              poster={testimonial.videoThumbnail}
              className="h-full w-full bg-black object-contain"
              controls
              autoPlay
            />
            <button
              onClick={onClose}
              aria-label="Close video"
              className="absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-black/70 text-white backdrop-blur transition hover:rotate-90 hover:border-royal-gold/60"
            >
              <Icon name="X" size={18} />
            </button>
          </div>

          <div className="p-6">
            <div className="flex flex-wrap items-center gap-4">
              <Image src={testimonial.avatar} alt={testimonial.name} className="h-14 w-14 rounded-full" />
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-xl font-bold text-white">{testimonial.name}</h3>
                <p className="text-xs text-white/45">{testimonial.location} · {testimonial.game}</p>
              </div>
              <div className="rounded-2xl border border-wa-green/30 bg-wa-green/10 px-4 py-2 text-right">
                <p className="text-[0.6rem] uppercase tracking-[0.16em] text-white/45">Withdrawn</p>
                <p className="font-display text-lg font-bold text-wa-green">{testimonial.winAmount}</p>
              </div>
            </div>

            <blockquote className="mt-5 border-l-2 border-royal-gold/60 pl-5 text-sm leading-relaxed text-white/65">
              “{testimonial.quote}”
            </blockquote>

            <button onClick={() => openWhatsApp(WA_MESSAGES.strategy)} className="btn-3d btn-3d-wa mt-6 w-full !py-3 text-sm">
              <FaWhatsapp size={17} /> Get the same coaching
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
